import { localizeHref } from "@/paraglide/runtime";
import NiceModal from "@ebay/nice-modal-react";
import { Store } from "@tanstack/react-store";
import { type UserInfoResponse, getUserInfo } from "./api";
import { LoginModal } from "./login-modal";

// 定义通道名称
export const AUTH_EVENT_TYPE = {
	LOGIN: "LOGIN",
	LOGOUT: "LOGOUT",
} as const;
export const authChannel = new BroadcastChannel("auth_channel");

function handleLogout() {
	localStorage.removeItem("AUTH_TOKEN");
	window.location.href = localizeHref("/");
}
authChannel.onmessage = (event) => {
	if (event.data.type === AUTH_EVENT_TYPE.LOGOUT) {
		handleLogout();
	} else if (event.data.type === AUTH_EVENT_TYPE.LOGIN) {
		window.location.href = localizeHref("/");
	}
};

export enum Region {
	CN = "CN",
	EN = "EN",
	ID = "ID",
	RU = "RU",
	FR = "FR",
	ES = "ES",
	DE = "DE",
}

export function getRegion() {
	const locale = localStorage.getItem("PARAGLIDE_LOCALE") as string;
	return (
		{
			zh: import.meta.env.DEV ? Region.CN : Region.EN,
			en: Region.EN,
			id: Region.ID,
			ru: Region.RU,
			fr: Region.FR,
			es: Region.ES,
			de: Region.DE,
		}[locale] || Region.EN
	);
}

export const authStore = new Store({
	user: null as UserInfoResponse | null,
	doLogin: () => {
		NiceModal.show(LoginModal);
	},
	doLogout: () => {
		authChannel.postMessage({
			type: AUTH_EVENT_TYPE.LOGOUT,
		});
		handleLogout();
	},
});

export const getUser = async () => {
	const user = await getUserInfo();
	if (user.code === 0 && user.data.user_id) {
		authStore.setState((t) => ({ ...t, user: user.data }));
	}
};
